import algoliasearch from 'algoliasearch';
import search from '~/views/search';

const axios = require('axios');
let defaultFirebase = require('~/firebase/index.js');
const firebase = defaultFirebase.default;
const { userFavorites } = require('~/assets/requests/user.js');
const { getProductData, getAttributes } = require('./firebase');
const { getFirebaseData, systemSettings } = require('~/firebase/functions');
/**
 * Adiciona um produto à lista de favoritos
 * @param {*} product_id - ID do produto
 */
export const addProductToFavorites = async (product_id) => {
    let user_id = localStorage.getItem('user_id');
    if (!product_id || !user_id) {
        return {
            status: false,
            message: 'invalid_product_id'
        }
    }
    try {
        let response_favorites = await userFavorites(user_id);
        if (response_favorites.status === false) {
            return {
                status: false
            }
        }
        let products = response_favorites.favorites;
        if ( !Array.isArray(products) ) {
            products = [];
        }
        products.push(product_id);
        await firebase.database().ref('users/' + user_id + '/favorites').set(products);
        return {
            status: true
        }
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Remove um produto da lista de favoritos
 * @param {*} product_id - ID do produto
 */
export const removeFromFavorites = async (product_id) => {
    let user_id = localStorage.getItem('user_id');
    if (!product_id || !user_id) {
        return {
            status: false,
            message: 'invalid_product_id'
        }
    }
    try {
        let response_favourites = await userFavorites(user_id);
        if (response_favourites.status === false) {
            return {
                status: false
            }
        }
        let products = response_favourites.favorites;
        if ( !Array.isArray(products) || products.length === 0 ) {
            return {
                status: false
            }
        }
        let indexOf = products.indexOf(product_id);
        if (indexOf >= 0) {
            products.splice(indexOf, 1);
        }
        await firebase.database().ref('users/' + user_id + '/favorites').set(products);
        return {
            status: true
        }
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Retornas os produtos adicionados aos favoritos
 */
export const getFavoriteProducts = async () => {
    let user_id = localStorage.getItem('user_id');
    if (!user_id) {
        return {
            status: false,
            message: 'invalid_user'
        }
    }
    try {
        let responseFavorites = await userFavorites(user_id);
        if (responseFavorites.status === false) {
            return {
                status: false
            }
        }

        let favorites = responseFavorites.favorites;
        let products = [];
        let loadPromisses = favorites.map( async product_id => {
            let responseProduct = await getProductData(product_id);
            if ( responseProduct.status === true ) {
                products.push(responseProduct.product);
            }
            return true;
        });
        await Promise.all(loadPromisses);
        return {
            status: true,
            products: products
        }
        
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Adiciona um novo produto à lista
 * @param {*} cart 
 * @param {*} product 
 * @returns void
 */
const pushToCart = (cart, product) => {
    cart.push(product);
    localStorage.setItem('cart', JSON.stringify(cart));
}
/**
 * Adiciona um novo produto à lista existente
 * @param {*} cart 
 * @param {*} product 
 * @returns void
 */
const appendProduct = (cart, product, indexProduct) => {
    product.attributes_selected.forEach((item, key) => {
        const indexAttribute = cart[indexProduct].attributes_selected.findIndex(item2 => (item2.childrenKey === item.childrenKey) && (item.colorKey === item2.colorKey));
        if (indexAttribute >= 0) {
            cart[indexProduct].attributes_selected[indexAttribute].quantity += product.attributes_selected[key].quantity;
        }
        else {
            cart[indexProduct].attributes_selected.push(item);
        }
    });

    localStorage.setItem('cart', JSON.stringify(cart));
}
/**
 * Adiciona um produto ao carrinho
 * @param {*} product - Produto incluindo o atributo selecionado
 */
export const addProductToCart = async (product) => {
    try {
        let cart = JSON.parse(localStorage.getItem('cart')) || [];
        if ( !Array.isArray(cart) ) cart = [];

        if (cart.length === 0) return pushToCart(cart, product);

        let indexProduct = cart.findIndex(item => item.product_id === product.product_id);
        if (indexProduct < 0) return pushToCart(cart, product);
        
        appendProduct(cart, product, indexProduct);
    }
    catch(error) {
        return {
            status: false,
            message: error
        }
    }
}
/**
 * Atualiza a lista de produtos no carrinho
 * @param {*} product_id 
 * @param {*} attributes 
 */
export const updateCart = (product_id, attributes) => {
    try {
        const newAttributes = attributes.filter(item => item.quantity !== 0);
        let cart = JSON.parse(localStorage.getItem('cart')) || [];
        if (cart.length === 0) return false;

        const indexOf = cart.findIndex(item => item.product_id === product_id);
        if (indexOf < 0) return false;
        
        if (newAttributes.length === 0) {
            cart.splice(indexOf, 1);
        }
        else {
            cart[indexOf].attributes_selected = newAttributes;
        }
        if (cart.length === 0) {
            localStorage.removeItem('cart');
        }
        else {
            localStorage.setItem('cart', JSON.stringify(cart));
        }
        return {
            status: true
        }
    }
    catch (error) {
        return {
            status: false,
            message: error
        }
    }
}
/**
 * Remove um produto do carrinho
 * @param {*} product - Produto incluindo o atributo selecionado
 */
export const removeProductFromCart = async (product) => {
    try {
        let cart = JSON.parse(localStorage.getItem('cart')) || [];
        if ( !Array.isArray(cart) ) cart = [];

        const { product_id, attribute_id, attribute_value } = product;
        if ( cart.length > 0 ) {
            let indexOf = cart.findIndex(item => item.product_id === product_id);
            if (indexOf >= 0) {
                let indexOf2 = cart[indexOf].attributes_selected.findIndex(item => item.attributeKey === attribute_id && item.childrenKey === attribute_value);
                if (indexOf2 >= 0) {
                    if ( cart[indexOf].attributes_selected[indexOf2].quantity > 1 ) {
                        cart[indexOf].attributes_selected[indexOf2].quantity -= 1;
                    } else if ( cart[indexOf].attributes_selected[indexOf2].quantity === 1 ) {
                        cart[indexOf].attributes_selected.splice(indexOf2, 1);
                        if (cart[indexOf].attributes_selected.length === 0) {
                            cart.splice(indexOf, 1);
                        }
                    }
                }
                localStorage.setItem('cart', JSON.stringify(cart));
                return {
                    status: true
                };
            }
        } else {
            return {
                status: false
            }
        }
    }
    catch(error) {
        return {
            status: false,
            message: error
        }
    }
}
/**
 * Remove todo o produto do carrinho
 * @param {*} product - Produto incluindo o atributo selecionado
 */
export const removeAllProductFromCart = async (product) => {
    try {
        let cart = JSON.parse(localStorage.getItem('cart')) || [];
        if ( !Array.isArray(cart) ) cart = [];

        const { product_id, attribute_id, attribute_value } = product;
        if ( cart.length > 0 ) {
            let indexOf = cart.findIndex(item => item.product_id === product_id);
            if (indexOf >= 0) {
                let indexOf2 = cart[indexOf].attributes_selected.findIndex(item => item.attributeKey === attribute_id && item.childrenKey === attribute_value);
                if (indexOf2 >= 0) {
                    cart[indexOf].attributes_selected.splice(indexOf2, 1);
                    if (cart[indexOf].attributes_selected.length === 0) {
                        cart.splice(indexOf, 1);
                    }
                }
                localStorage.setItem('cart', JSON.stringify(cart));
                return {
                    status: true
                };
            }
        } else {
            return {
                status: false
            }
        }
    }
    catch(error) {
        return {
            status: false,
            message: error
        }
    }
}
/**
 * Retorna todos os produtos adicionados ao carrinho
 */
export const getProductsCart = async () => {
    let cart = JSON.parse(localStorage.getItem('cart')) || [];
    if ( !Array.isArray(cart) ) cart = [];

    try {
        let products = [];
        let attributes = [];
        let total_price = 0;
        let loadPromisses = cart.map( async (product) => {
            let responseProduct = await getProductData(product.product_id);
            if ( responseProduct.status === true ) {
                let productData = {
                    ...responseProduct.product,
                    attributes: product.attributes_selected,
                    weights: responseProduct.weights,
                    colors: responseProduct.colors
                };
                await Promise.all(
                    product.attributes_selected.map((item) => {
                        total_price += (productData.price * item.quantity);
                    })
                )
                products.push(productData);
            }
            return true;
        });
        await Promise.all(loadPromisses);
        let response = await getAttributes();
        if ( response.status === true ) {
            attributes = response.attributes;
        }
        return {
            status: true,
            products: products,
            attributes: attributes,
            total_price: total_price
        }
        
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Retorna as cidades disponíveis para venda do produto
 */
export const availableLocations = async () => {
    try {
        let repsonse = await getFirebaseData('availableLocations');
        if ( repsonse.status === true ) {
            return {
                status: true,
                location: repsonse.data
            }
        } else {
            return {
                status: false,
                message: 'nothing_location_available'
            }
        }
        
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Retorna os dados de entrega do produto caso válido o endereço
 * @param {*} zip_code 
 */
export const getAddressDelivery = async (zip_code) => {
    if (!zip_code) {
        return {
            status: false
        }
    }
    try {
        const body = {
            "origin": zip_code,
            "destiny": zip_code,
            "weight": 20,
            "length": 20,
            "height": 20,
            "width": 20,
            "diameter": 20
        }
        const options = {
            
        }
        let response = await axios.post('https://cors-anywhere.herokuapp.com/https://us-central1-tookas-55a71.cloudfunctions.net/fareCalc', body, options);
        if ( response.data && response.data.success === true ) {
            return {
                status: true,
                data: response.data
            }
        } else {
            return {
                status: false
            }
        }
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Atualiza o cupom com a contagem de usado
 * @param {*} discountId 
 */
const updateVoucherUsed = async (discountId) => {
    try {
        let response = await getFirebaseData(`vouchers/${discountId}`);
        if ( response.status === true ) {
            let voucher = response.data;
            voucher.used += 1;
            await firebase.database().ref(`vouchers/${discountId}/used`).set(voucher.used);
            return {
                status: true
            }
        } else {
            return {
                status: false,
                message: 'not_found'
            }
        }
        
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Atualiza o total de pedidos realizados
 * @returns object
 */
export const updateTotalOrders = async () => {
    try {
        const settings = await systemSettings();
        await firebase.database().ref('settings/orderSettings/total').set(settings.data.orderSettings.total+1);
        return {
            status: true,
            values: settings.data.orderSettings.total+1
        }
    }
    catch (error) {
        return {
            status: false,
            message: error.message
        }
    }
}
/**
 * Cria um novo pedido de produtos
 * @param {*} order_data - dados do pedido
 * @return retorna o id do pedido
 */
export const createOrder = async (order_data) => {
    try {
        let order_id = localStorage.getItem('order_id');
        if (order_id) {
            return {
                status: true,
                order_id: order_id
            }
        }
        let user_id = localStorage.getItem('user_id');
        if (!user_id) {
            return {
                status: false
            }
        }

        order_data.user_id = user_id;

        let products = [];
        let localProducts = JSON.parse(localStorage.getItem('cart')) || [];
        if ( !Array.isArray(localProducts) || localProducts.length === 0 ) {
            return {
                status: false
            }
        }
        let colors = await getFirebaseData(`colors`);
        colors = colors.data;
        let loadPromisses = localProducts.map( async (product) => {            
            let responseProduct = await getProductData(product.product_id);
            if ( responseProduct.status === true ) {
                let productData = {};
                await Promise.all(
                    product.attributes_selected.map((item) => {
                        const colorName = colors[item.colorKey].name;
                        productData = Object.assign({}, responseProduct.product);
                        products.push({
                            attributes: item,
                            product: productData,
                            quantity: item.quantity,
                            colorName: colorName,
                            colorKey: item.colorKey,
                            colors: responseProduct.colors
                        });
                    })
                )
            }
            return true;
        });
        await Promise.all(loadPromisses);
        if (products.length === 0) {
            return {
                status: false,
                message: 'cannot_create_order'
            }
        }
        const observation = order_data.observation;
        const quinzena = order_data.quinzena;
        const totalPrice    = order_data.fare_price + order_data.total_price;
        let settings = await systemSettings();
        let userData = await getFirebaseData(`users/${user_id}`);
        userData = userData.data;

        let newData = {
            "createdAt" : new Date().getTime(),
            "delivery" : order_data.deliveryMode === 1 ? 0 : settings.data.paymentSettings.staticDelivery,
            "deliveryAddress" : {
                "additional" : order_data.complement || "",
                "address" : order_data.street || "",
                "city" : order_data.city || "",
                "district" : order_data.district || "",
                "number" : order_data.number || "",
                "state" : order_data.state || "",
                "zip_code" : order_data.zip_code
            },
            "deliveryMode" : order_data.deliveryMode,
            "discount" : order_data.discount,
            "discountId" : order_data.discountId,
            "fare" : order_data.fare_price,
            "price" : order_data.total_price,
            "products" : products,
            "status" : 1,
            "totalPrice" : totalPrice,
            "user" : user_id,
            "percentage": 0,
            "observation": observation,
            "Agendamento": quinzena,
            "orderNumber": settings.data.orderSettings.total+1
        }

        let response = firebase.database().ref('orders').push(newData).key;
        if ( response ) {
            updateTotalOrders();
            if (order_data.discountId !== null) updateVoucherUsed(order_data.discountId);
            return {
                status: true,
                order_id: response,
                isCnpj: userData.isCnpj || false
            }
        } else {
            return {
                status: false
            }
        }
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Retorna as informações de um pedido
 * @param {*} orderId - id do pedido
 */
export const getOrderData = async (orderId) => {
    try {
        if (!orderId) {
            return {
                status: false,
                message: 'invalid_order'
            }
        }
        let response = await getFirebaseData('orders/' + orderId);
        if ( response.status === true ) {
            return {
                status: true,
                data: response.data
            }
        } else {
            return {
                status: false,
                message: 'invalid_order'
            }
        }
    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Realiza um pagamento
 * @param {*} orderId 
 */
export const processPaymentOrder = async (payment_data) => {
    try {
        if (!payment_data) {
            return {
                status: false,
                message: 'invalid_order'
            }
        }

        localStorage.setItem('order_id', payment_data.id);
        let order = await getOrderData(payment_data.id);
        const options = {}
        const body = payment_data;
        if (order.status === true) {
            let response = await axios.post('https://cors-anywhere.herokuapp.com/https://us-central1-tookas-55a71.cloudfunctions.net/paymentByCardSandbox', body, options);
            if ( response.data && response.data.success === true ) {
                localStorage.removeItem('order_id');
                localStorage.removeItem('cart');
                return {
                    status: true
                }
            } else {
                return {
                    status: false,
                    message: response.data.errorCode === -1 ? 'not_quantity_available' : 'payment_error'
                }
            }
        } else {
            return {
                status: false,
                message: 'invalid_order'
            }
        }

    }
    catch(error) {
        let error_code = error.message || 'request_failed';
        error_code = error_code.replace(/[/\\-]/g, '_');
        error_code = error_code.toLowerCase();
        if (error_code.length === '') error_code = 'request_failed';
        return {
            status: false,
            message: error_code
        }
    }
}
/**
 * Retorna os pedidos de um usuário
 * @return Object
 */
export const getProductsOrders = async () => {
    try {
        let user_id = localStorage.getItem('user_id');
        if (!user_id) {
            return {
                status: false
            }
        }

        let consultFirebase = await firebase.database().ref('orders').orderByChild("user").equalTo(user_id).once('value');
        let response = consultFirebase.val();
        let orders = [];
        if ( response && Object.keys(response).length > 0 ) {
            let attributes = [];
            Object.values(response).map( (item, key) => {
                if (item.products) {
                    item._id = Object.keys(response)[key];
                    item.products.map( (subItem, key) => {
                        subItem.product.attribute_selected = {
                            _id: subItem.attributes.attributeKey,
                            value: subItem.attributes.childrenKey
                        };
                        subItem.product.quantity = subItem.quantity;
                        subItem.product._id = subItem.product._id;
                        subItem.product.details = subItem.attributes;
                        subItem.product.colors = subItem.colors;
                        item.products[key] = subItem.product;
                        return true;
                    });
                    orders.push(item);
                }
                return true;
            });

            let responseAttributes = await getAttributes();
            if ( responseAttributes.status === true ) {
                attributes = responseAttributes.attributes;
            }
            orders.sort((a, b) => {
                return b.createdAt - a.createdAt;
            })
            return {
                status: true,
                orders: orders,
                attributes: attributes
            }
        } else {
            return {
                status: false,
                message: 'empty_orders'
            }
        }

    }
    catch(error) {
        return {
            status: false,
            error
        }
    }

}
/**
 * Realiza uma pesquisa de produtos pelo Algolia
 * @param {*} search 
 * @returns object
 */
export const searchByAlgolia = async (query) => {
    try {
        const clientAlgolia = algoliasearch(process.env.REACT_APP_ALGOLIA_APP_ID, process.env.REACT_APP_ALGOLIA_API_KEY);
        const algoliaProductsIndex = clientAlgolia.initIndex('products');
        const response = await algoliaProductsIndex.search(query);
        return {
            status: true,
            values: response.hits || []
        }
    }
    catch (error) {
        return {
            status: false,
            message: error.message
        }
    }
}
/**
 * Retorna uma lista de produtos a partir de uma pesquisa
 * @return Object
 */
export const getProductsBySearch = async (query) => {
    try {
        let response = await searchByAlgolia(query);
        if (response.status === false) {
            response = []
        }
        else {
            response = response.values
        }
        if ( response.length > 0 ) {

            response.forEach((item, key) => {
                if (!item.images || !Array.isArray(item.images)) {
                    item.images = [{
                        url: process.env.PUBLIC_URL + '/images/no-product-image.png',
                        colorKey: 'not-color-key'
                    }];
                }
                item.images.forEach((item2, key2) => {
                    if (typeof item2 !== 'object') {
                        item.images[key2] = {
                            url: item2,
                            colorKey: 'not-color-key'
                        }
                    }
                })
                item._id = item.productKey;
                response[key] = item;
            })
            
            return {
                status: true,
                products: response,
                attributes: [],
                ads: {}
            }
        } else {
            return {
                status: false,
                message: 'empty_orders'
            }
        }

    }
    catch(error) {
        return {
            status: false,
            error
        }
    }

}
/**
 * Retorna uma lista de cupons
 */
export const getCupoms = async () => {
    try {
        let response =  await getFirebaseData('vouchers');
        if (response.status === true) {
            let discounts = [];
            Object.keys(response.data).forEach(item => {
                let discount = {
                    _id: item
                }
                for (let key in response.data[item]) {
                    discount[key] = response.data[item][key]
                }
                discounts.push(discount);
            });
            return {
                status: true,
                data: discounts
            }
        } else {
            return {
                status: false,
                message: 'none_discount'
            }
        }
    }
    catch(error) {
        return {
            status: false,
            message: error.message
        }
    }
}